import React from 'react';

import { ReactComponent as IconHotels } from 'assets/images/rappi_hotels.svg';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { TravelHotelSearch_HotelLocation_Response, TravelHotelSearch_Location_Response } from 'models/hotelLocation';

import Result from './styles';

export interface Props {
  location?: TravelHotelSearch_Location_Response;
  hotelLocation?: TravelHotelSearch_HotelLocation_Response;
  type?: string;
  onClick: (data: TravelHotelSearch_Location_Response | TravelHotelSearch_HotelLocation_Response) => void;
}

const ResultItem = ({ location, hotelLocation, type, onClick }: Props) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { t } = useStoreTranslation();

  return (
    <>
      {type === 'location' && location && (
        <Result onClick={() => onClick(location)}>
          <Result.info>
            <Result.Title>
              {location?.Type !== 'airport' && <Result.icon />}
              {location?.Type === 'airport' && <Result.iconairport />}
              {`${location?.Name}`}
            </Result.Title>
            <Result.SubTitle>
              {location?.Type === 'point_of_interest'
                ? location?.NameFull
                  ? location?.NameFull?.split(',')?.shift()
                  : location?.NameFull
                : location?.NameFull}
            </Result.SubTitle>
          </Result.info>
        </Result>
      )}

      {type === 'hotel' && hotelLocation && (
        <Result onClick={() => onClick(hotelLocation)}>
          <Result.info>
            <Result.Title>
              <Result.IconContainer>
                <IconHotels />
              </Result.IconContainer>
              {`${hotelLocation?.hotel_name}`}
            </Result.Title>
            <Result.SubTitle>{hotelLocation?.address}</Result.SubTitle>
          </Result.info>
        </Result>
      )}
    </>
  );
};

export default ResultItem;
